module.exports = __webpack_public_path__ + "static/media/AB_PWZ7_1.5018a9a1.jpg";